<template>

  <b-overlay
    :show="slideList == null"
    opacity="0.9"
    spinner-variant="primary"
    spinner-small
    rounded="md"
    class="div-container text-center"
  >
    <template
      v-slot:overlay
    >
  
      <div style="display:flex; align-items: center; flex-direction: column;">
        <b-spinner
          style="width: 4rem; height: 4rem;"
        />
        <div
          class="mt-1"
          style="text-align: center"
        >
          <span> <strong>{{ pings.text }}</strong><br></span> <span v-if="pings.showUpdate"> Loading</span>
        </div>
   
      </div>
    </template>
    <div
      v-if="refreshing"
      class="div-container text-center vertical-middle"
    >
    <b-spinner
          style="width: 4rem; height: 4rem; margin-bottom: 10px;"
        />
    <div v-if="time_update != '' || time_update == null || time_update == undefined" style="margin-left:10px;">
      Refreshing image ... {{  time_update}}
    </div>
    <div v-else style="margin-left:10px">
      Refreshing image ... In queue
    </div>
  
   
    </div>
    <div
      v-else-if="slideList !== null"
      class="div-container text-center"
    >
      <b-row>
        <b-col class="selectBar">
          
          <h1 class="resTitle"> Results</h1>
          
         
        </b-col>
      </b-row>
      <b-row v-if="nextStep">
        <b-col>
          <b-img
            v-if="image !== null"
            fluid-grow
            :src="'data:image/jpeg;base64, ' + image"
            class="cellImage"
          />
          <b-img
            v-if="image === null"
            fluid-grow
            :src="noimage"
            class="cellImage"
          />
          {{ dr_path }}
        </b-col>
        <b-col class="colorlist">
          <div style="display:flex;" >
            <b-form-group
            class="mt-1 mr-2"
            style="min-width: 250px; text-align:left;"
          >
            <h6>
              Slide
            </h6>
            <v-select
              v-model="slide"
              placeholder="Select a Slide"
              tag-placeholder=" "
              :options="slideList"
              :multiple="false"
              :taggable="false"
              class="mr-1 mb-2"
            />
          </b-form-group>
          <b-form-group
            class="mt-1 mr-2"
            style="min-width: 250px; text-align:left;"
          >
            <h6>
              Scene
            </h6>
            <v-select
              v-model="scene"
              :disabled="slide === null"
              placeholder="Select a Scene"
              tag-placeholder=" "
              :options="sceneList"
              :multiple="false"
              :taggable="false"
              class="mr-1"
            />
          </b-form-group>
          </div>
          
          <div
            v-for="item, name in colorList"
            :key="name"
            class="colorItem"
          >
            <div>{{ name }}</div>
            <input-color-picker
              v-model="colorList[name]"
            />
            <div class="ml-2">
              {{ colorList[name] }}
            </div>
          </div>
          <div class="colorButtons">
            <b-button
              :disabled="slide === null || scene === null"
              variant="outline-primary"
              style="margin-top: 25px!important; margin-right: 25px!important;"
              @click="refresh(false)"
            >
              REFRESH IMAGE
            </b-button>
            <b-button
              variant="outline-danger"
              style="margin-top: 25px!important;"
              @click="computeAll"
            >
              GENERATE ALL
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
   <!---- <b-button
                  variant="primary"
                  class="rounded"
                  size="sm"
                  style="position: absolute;  top: 18px;  background: white;  right: 20px;"
                  @click="show_cells"
                >
                  SELECT CELLS
                </b-button>-->
  </b-overlay>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable no-empty */
 import Vue from 'vue'
import {
  BSpinner, BOverlay, BButton, BRow, BCol, BFormGroup, BImg,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import 'vue-select/dist/vue-select.css'
import InputColorPicker from 'vue-native-color-picker'
import hexRgb from 'hex-rgb'
import rgbHex from 'rgb-hex'
import Multiselect from 'vue-multiselect'
import SelectCells from './SelectCells.vue'
import vSelect from 'vue-select'

const noimage = require('@/assets/images/noimage.jpg')

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BSpinner,
    vSelect,
    SelectCells,
    BOverlay,
    BButton,
    InputColorPicker,
    BRow,
    BCol,
    Multiselect,
    BFormGroup,
    BImg,
  },
  props: {
    version: {
      required: false,
      type: Number,
      default: 0,
    },
    update: {
      required: false,
      type: Number,
      default: 0,
    },
    project_id:{
      required: false,
      type: Number,
      default: 0,

    }
  },
  data() {
    return {
      image: '',
      time_update:'',
      refreshing:false,
      noimage,
      computeBt: true,
      colored: '',
      imagelist: null,
      scene: null,
      slide: null,
      colorList: null,
      colorhex: {},
      getPings: false,
      slideList: null,
      sceneList: [],
      nextStep: false,
      pings_updated: '',
      annotation: [],
      dr_path: '',
      pings: {
        active: false,
        showUpdate: true,
        updated: '',
        tasks: [],
        text: '',
        progress: { id: 0, timestamp: '', percent: 0 },
        ps: {
          cpu: '', 'RAM (GB)': '', 'RAM (%)': '', 'Running Time (seconds)': '',
        },
      },
    }
  },
  computed: {
    showComputing() {
      return this.pings.active
    },
    btImageText() {
      return (this.image !== '') ? 'REGENERATE IMAGE' : 'GENERATE IMAGE'
    },
    celltypes_colored() {
      const colors = Object.keys(this.colorList)
      const colored = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < colors.length; index++) {
        const key = colors[index]
        const element = this.colorList[key]
        console.log(element)
        const rgb = hexRgb(element)
        colored.push({
          CellType: key, celltype_id: index, R: this.color2percent(rgb.red) * 1, G: this.color2percent(rgb.green) * 1, B: this.color2percent(rgb.blue) * 1,
        })
      }
      return colored
    },
  },
  watch: {
    imagelist(to, from) {
      console.log("IMAGE LIST ES", to)
      this.slideList = (this.imagelist !== null) ? Object.keys(this.imagelist) : null
      console.log("SLIDE LIST ES", this.slideList)
      console.log('imagelist', to, from, this.slideList)
    },
    slideList() {
      if (this.slideList !== null && this.slideList.length === 0) {
        this.slideList = null
      }
    },
    slide() {
      if (this.slide !== null && this.slide !== '') {
        this.sceneList = this.imagelist[this.slide]
      } else {
        this.sceneList = []
      }
    },
    getPings(to, from) {
      if (to !== from) {
        if (this.getPings === true) {
          this.statusWhile(this.pings.tasks)
        }
      }
    },
    version() {
      this.renderPage()
      /* console.log('changeVersion')
      this.getData() */
    },
    update() {
      this.renderPage()
      /* this.computeBt = true
      this.getData() */
    },
  },
  mounted() {
    this.renderPage()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    show_cells(){
    
      const cellsSelect = new Vue({
        ...SelectCells,
     
        propsData: { id:8}
      }).$mount()
      this.$swal({
        html: cellsSelect.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Save',
        width: '90%',
      

      }).then(async result => {
          if (result.dismiss == undefined) {
        
          }
        })
    },
    async renderPage() {
      this.getPings = false
      const status = await this.tasktype_status(['11.1', '11.2', '11.3', '11.4', '11.5'])
      console.log('status', status)
      if (status === '1') {
        this.pings.active = true
        this.getPings = true
        // this.getData()
      }
    },
    compute() {
      console.log('compute')
      this.computeBt = false
      if (this.version !== undefined) {
        axios.post(`${url}:${port}/digital-prepare/${this.version.id}`, {}, { headers }).then(result => {
          console.log(result)
          this.prepare()
        })
      }

      /* this.pings.active = true
      this.pings.text = 'Preparing Digital Reconstruction'
      this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
      let i = 0
      const timer = setInterval(() => {
        this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
        i += 1
        if (i === 5) {
          clearInterval(timer)
          this.pings.active = false
          this.getData()
        }
      }, 1000) */
    },
    async getVersions() {
      this.computing = []
      //const { id } = this.$route.params
       const id = this.project_id;
      await axios.get(`${url}:${port}/downstream-dig-versions/${id}`, { headers }).then(async result => {
        if (result) {
          const versions = []
          result.data.versions.forEach(element => {
            // eslint-disable-next-line no-param-reassign
            element.idv = element.id
            versions.push(element)
          })
         // versions[0]['description'] = 'Primera prueba'
          //versions[0]['idv'] = '3'
          this.versions = versions
          var is_timeupdate = false;
         
         // this.section = 'versions'
          // eslint-disable-next-line no-plusplus
          for (let index = 0; index < this.versions.length; index++) {
            const element = this.versions[index]
           
            if (element.id == this.version) {
              if(element.display_image == 1){
                this.refreshing = false;
               
              this.renderPage()
              clearInterval(this.timer)
              
              
              
            }
              this.time_update = element.time_update
              is_timeupdate = true;
            }
          }
        }
        if(is_timeupdate == false){
          this.time_update = 'In queue'
        }
      })
      return ''
    },
   get_time_update(){
    
    this.timer = setInterval(() => {
      this.getVersions()
      }, 1000)
    
    
      
    },
    prepare() {
      console.log('prepare')
      this.getPings = false
      this.pings.active = true
      this.pings.text = 'Preparing Digital Reconstruction'
      this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
      this.pings_updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
      this.pings.tasks = ['11.1', '11.2', '11.3', '11.4']
      this.getPings = true
    },
    generate() {
      this.getPings = false
      const data = { image: this.scene, slide: this.slide }
      console.log(data)
      axios.post(`${url}:${port}/digital-generation/${this.version.id}`, data, { headers }).then(result => {
        this.getPings = true
        console.log(result)
        if (result) {
        }
      })
      this.pings.active = true
      this.pings.text = 'Generating Image'
      this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
      this.pings_updated = this.pings.updated
      /* setInterval(() => {
        this.getPings = true
      }, 2000)
      /* let i = 0
      const timer = setInterval(() => {
        this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
        i += 1
        if (i === 240) {
          clearInterval(timer)
          this.pings.active = false
          this.nextStep = true
          this.getData()
        }
      }, 1000)
      */
    },
    resetData() {
      this.pings = {
        active: false,
        tasks: [],
        text: '',
        updated: '',
        showUpdate: true,
        progress: { id: 0, timestamp: '', percent: 0 },
        ps: {
          cpu: '', 'RAM (GB)': '', 'RAM (%)': '', 'Running Time (seconds)': '',
        },
      }
    },
    pingData(task) {
      if ((['11.1', '11.2', '11.3', '11.4']).includes(task)) {
        this.pings.text = 'Preparing Digital Reconstruction Data'
        this.pings.tasks = ['11.1', '11.2', '11.3', '11.4']
        this.pings.active = true
        this.getPings = true
      }
      /* if ((['11.4']).includes(task)) {
        this.pings.text = 'Generating Image'
        this.pings.tasks = ['11.4']
        this.pings.active = true
        this.getPings = true
      } */
      if ((['11.5']).includes(task)) {
        this.pings.text = 'Image Refresh'
        this.pings.tasks = ['11.5']
        this.pings.active = true
        this.getPings = true
      }
    },
    async getData() {
      /* consolethis.pings.tasks = ['11.1', '11.2', '11.3']
      const status = await this.tasktype_status(this.pings.tasks)
      console.log('getData', status) */
      if (this.version !== null) {
        const version = this.version
        axios.get(`${url}:${port}/digital-reconstruction/${version}`, { headers }).then(result => {
          console.log('result', result)
          if (result) {
            const {
              imagelist, dr_slide, dr_scene, dr_image, dr_colored, annotation, dr_imgpath, clusters
            } = result.data.data
            this.slide = dr_slide
            this.scene = dr_scene
            this.dr_path = dr_imgpath
            this.imagelist = (imagelist !== '' && imagelist !== null) ? JSON.parse(imagelist) : {}
            console.log('imagelist', this.slideList)
            this.image = dr_image
            this.annotation = clusters
            this.colored = (dr_colored !== '' && dr_colored !== null) ? dr_colored : null
            if (this.colored !== null || (this.slide !== '' && this.scene !== '')) {
              this.nextStep = true
              this.genColored()
            }
          }
        })
      }
    },
    genColored() {
      console.log('getcolored', this.annotation)
      this.setcolored()
      const annotation = JSON.parse(this.annotation)
      // const savedColored = (this.colored !== '') ? JSON.parse(this.colored) : {}
      const colored = {}
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < annotation.length; index++) {
        const element = annotation[index]
        const color = this.colorhex[element.cell_id]
       // if (element.annotated === 1) {
          colored[element.cell_id] = (color !== undefined) ? `#${color}` : '#000000'
      //  }
      }
      this.colorList = colored
      this.nextStep = true
    },
    setcolored() {
      console.log('setcolored', this.colored)
      const returned = {}
      const colored = JSON.parse(this.colored)
      if (colored !== null) {
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < colored.length; index++) {
          const element = colored[index]
          const r = this.percent2color(element.R) * 1
          const g = this.percent2color(element.G) * 1
          const b = this.percent2color(element.B) * 1
          const color = rgbHex(r, g, b)
          returned[element.CellType] = color
        }
      }
      console.log("getco", returned)
      this.colorhex = returned
    },
    refresh(forceCompute = false) {
      /*this.resetData()
      this.getPings = false
      this.pings.tasks = ['11.5']
      this.pings.text = 'Image Refresh'
      this.pings.active = true
      this.image = ''
      this.pings.updated = this.$moment().format('yyyy-MM-DD HH:mm:ss')
      this.pings_updated = this.pings.updated*/
      const image = (forceCompute) ? '' : this.scene
      const { slide, project_id } = this
      console.log('force', forceCompute)
      console.log('refresh')
      console.log(JSON.stringify(this.celltypes_colored))
      axios.post(`${url}:${port}/digital-reconstruction/${this.version}/${project_id}`, { image, df_consensus_celltypes_colored: this.celltypes_colored, slide }, { headers }).then(result => {
        console.log('refresh2')
        console.log(result)
        this.refreshing = true;
        this.get_time_update()
        //this.getPings = true
      //  this.$swal.close()
        /* if (result) {
          const { dr_colored } = result.data
          this.image = result.data.dr_image
          this.colored = (dr_colored !== '' && dr_colored !== null) ? JSON.stringify(dr_colored) : ''
          this.genColored()
          this.pings.active = false
          this.getPings = false
        } */
      })
      /*setInterval(() => {
        this.getPings = true
      }, 5000)*/
    },
    async computeAll() {
      console.log('computeAll')
      this.refresh(true)
    },
    color2percent(value) {
      const percent = value / 255
      return (percent < 1 && percent > 0) ? percent.toFixed(2) : percent
    },
    percent2color(value) {
      const color = value * 255
      return color.toFixed()
    },
    async tasktype_status(tasks) {
      console.log('tasktypeStatus', tasks)

      const id  = this.project_id
      let statusTasks = 0
      if (this.version) {
        const version = this.version.id
        await axios.post(`${url}:${port}/tasktype-status/${id}`, { tasks }, { headers }).then(result => {
          console.log('tasktype_status', result)
          const { status } = result.data
          statusTasks = (status !== undefined) ? status.length : 0
          console.log('tasktype_status1', tasks, statusTasks, status)
          if (statusTasks > 0 && status[0].json.version_id * 1 === version) {
            this.pingData(status[0].json.task_type)
            const ps = status[0]
            const lastPing = this.pings.updated
            this.pings.progress = (ps.progress !== null) ? ps.progress : this.pings.progress
            this.pings.ps = (ps.ts !== null && ps.ts.data !== null) ? JSON.parse(ps.ts.data) : ''
            const newPing = (ps.pings.timestamp > lastPing) ? ps.pings.timestamp : lastPing
            this.pings.updated = (ps.progress !== null) ? ps.progress.timestamp : newPing
            this.pings_updated = this.pings.updated
            console.log('progress', newPing)
            console.log('tasktype_status2', this.pings)
          } else {
            this.pings.active = false
            this.getData()
          }
        })
      }
      return statusTasks
    },
    async statusWhile(tasks) {
      while (this.pings.active === true) {
        // eslint-disable-next-line no-await-in-loop
        await this.tasktype_status(tasks)
        console.log('ping')
        this.sleep(5000)
      }
    },
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms)
      })
    },
  },
}
</script>
<style>
.vertical-middle{
    display: flex;
    justify-content: center;
    align-items: center;
}
.resTitle{
  padding-left: 50px;
  margin-bottom: 20px;

}
.selectBar{
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
  justify-content: left;
}
.icp__input{
  border: solid 1px #000000!important
}
.colorlist{
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: flex-start;
}
.colorItem{
    display: flex;
    align-content: center;
    align-items: center;
    margin-bottom: 10px;
}


.colorlist .vs__selected {
    color: black !important;
}
.colorItem div{
  margin-right: 20px;
  min-width:40px
}
.cellImage{
  padding: 0px 50px 50px 50px;
}
</style>
